/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AncillarySupplierListConfiguration,
    AncillarySupplierListConfigurationFromJSON,
    AncillarySupplierListConfigurationToJSON,
    AncillarySupplierListItem,
    AncillarySupplierListItemFromJSON,
    AncillarySupplierListItemToJSON,
    AncillarySupplierListQuery,
    AncillarySupplierListQueryFromJSON,
    AncillarySupplierListQueryToJSON,
} from '../models';

export interface ApiAncillarySupplierListConfigurationGetRequest {
    ancillaryCategoryId?: number;
}

export interface ApiAncillarySupplierListDataPostRequest {
    ancillarySupplierListQuery?: AncillarySupplierListQuery;
}

/**
 * no description
 */
export class AncillarySupplierListApi extends runtime.BaseAPI {

    /**
     */
    async apiAncillarySupplierListConfigurationGetRaw(requestParameters: ApiAncillarySupplierListConfigurationGetRequest): Promise<runtime.ApiResponse<AncillarySupplierListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.ancillaryCategoryId !== undefined) {
            queryParameters['ancillaryCategoryId'] = requestParameters.ancillaryCategoryId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillarySupplierList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AncillarySupplierListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiAncillarySupplierListConfigurationGet(requestParameters: ApiAncillarySupplierListConfigurationGetRequest): Promise<AncillarySupplierListConfiguration> {
        const response = await this.apiAncillarySupplierListConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAncillarySupplierListDataPostRaw(requestParameters: ApiAncillarySupplierListDataPostRequest): Promise<runtime.ApiResponse<Array<AncillarySupplierListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillarySupplierList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AncillarySupplierListQueryToJSON(requestParameters.ancillarySupplierListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AncillarySupplierListItemFromJSON));
    }

    /**
     */
    async apiAncillarySupplierListDataPost(requestParameters: ApiAncillarySupplierListDataPostRequest): Promise<Array<AncillarySupplierListItem>> {
        const response = await this.apiAncillarySupplierListDataPostRaw(requestParameters);
        return await response.value();
    }

}
